<template>
    <div class="p-fluid formgrid grid mt-10">
        <div class="field col-12 md:col-6">
            <label for="nik">NIK</label>
            <InputText id="nik" type="text" v-model="model.nik" :disabled=true />
        </div>
        <div class="field col-12 md:col-6">
            <label for="idcard">ID Card Number</label>
            <InputText id="idcard" type="text" v-model="model.id_card_number" :disabled=true />
        </div>
        <div class="field col-12">
            <label for="name">Name</label>
            <InputText id="name" type="text" v-model="model.name" :disabled=true />
        </div>
        <div class="field col-12 md:col-4">
            <label for="birthplace">Birthplace</label>
            <InputText id="birthplace" type="text" v-model="model.birthplace" :disabled=true />
        </div>
        <div class="field col-12 md:col-4">
            <label for="birthdate">Birthdate</label>
            <InputText id="birthdate" type="text" v-model="model.birthdate" :disabled=true />
        </div>
        <div class="field col-12 md:col-4">
            <label for="gender">Gender</label>
            <Dropdown v-model="model.gender" :options="genders" option-label="name" option-value="code" placeholder="Select Gender" :disabled=true ></Dropdown>
        </div>
        <div class="field col-12 md:col-4">
            <label for="blood_type">Blood Type</label>
            <Dropdown v-model="model.blood_type" :options="blood_types" placeholder="Select Blood Type" :disabled=true ></Dropdown>
        </div>
        <div class="field col-12 md:col-6">
            <label for="last_modelal_education">Last Formal Education</label>
            <Dropdown v-model="model.last_formal_education_id" :options="educations" option-label="name" option-value="id" placeholder="Select Education" :disabled=true ></Dropdown>
        </div>
        <div class="field col-12 md:col-2">
            <label for="gpa">GPA</label>
            <InputText id="gpa" type="text" v-model="model.gpa" :disabled=true />
        </div>
        <div class="field col-12 md:col-2">
            <label for="religion">Religion</label>
            <Dropdown v-model="model.religion" :options="religions" placeholder="Select Religion" :disabled=true ></Dropdown>
        </div>
        <div class="field col-12 md:col-2">
            <label for="nationality">Nationality</label>
            <Dropdown v-model="model.nationality" :options="nationalities" option-label="name" option-value="id" placeholder="Select Nationalities" :disabled=true ></Dropdown>
        </div>
        <div class="field col-12 md:col-6">
            <label for="clan">Clan</label>
            <InputText id="clan" type="text" v-model="model.clan" :disabled=true />
        </div>
        <div class="field col-12 md:col-2">
            <label for="marital_status">Marital Status</label>
            <Dropdown v-model="model.marital_status" :options="marital_statuses" placeholder="Select Marital Status" :disabled=true ></Dropdown>
        </div>
        <div class="field col-12 md:col-4">
            <label for="telephone_number">Telephone Number</label>
            <InputText id="telephone_number" type="text" v-model="model.telephone_number" :disabled=true />
        </div>
        <div class="field col-12 md:col-4">
            <label for="phone_number">Phone Number</label>
            <InputText id="phone_number" type="text" v-model="model.phone_number" :disabled=true />
        </div>
        <div class="field col-12 md:col-4">
            <label for="email">Email</label>
            <InputText id="email" type="text" v-model="model.email" :disabled=true />
        </div>
        <div class="field col-12">
            <label for="address">Address</label>
            <Textarea id="address" rows="4" v-model="model.address" readonly />
        </div>
        <div class="field col-12 md:col-6">
            <label for="email">Nama Rekening</label>
            <InputText id="email" type="text" v-model="model.bank.account_name" :disabled=true />
        </div>
        <div class="field col-12 md:col-3">
            <label for="email">Bank</label>
            <InputText id="email" type="text" v-model="model.master_bank.name" :disabled=true />
        </div>
        <div class="field col-12 md:col-3">
            <label for="email">No Rekening</label>
            <InputText id="email" type="text" v-model="model.bank.account_number" :disabled=true />
        </div>
    </div>
    <div class="grid formgrid right-0">
        <div v-if="(model.foto != 'none' || !model.foto)" class="col-6">
            &nbsp;
            <Image
                :src="model.foto"
                preview="true"
                width="250"
            />
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Image from 'primevue/image';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Textarea from 'primevue/textarea';

export default {
    components: {InputText, Image, Dropdown, Textarea, TabView, TabPanel, Button},
    props:['model'],
    data(){
        return{
            genders: [
                {name: 'Laki-Laki', code: 'Laki-laki'},
                {name: 'Perempuan', code: 'Perempuan'},
            ],
            blood_types: ["A", "B", "O", "AB"],
            educations: "",
            religions: ['Islam','Katolik','Kristen','Hindu','Budha'],
            nationalities: "",
            marital_statuses: ['married','single','widow'],
        }
    },
    mounted(){
        this.initData();
    },
    methods: {
        initData(){
            axios.get(`${this.$page.props.appUrl}api/education-levels`)
            .then((data) => {
                this.educations = data.data.data
            });
            axios.get(`${this.$page.props.appUrl}api/nationalities`)
            .then((data) => {
                this.nationalities = data.data.data
            });
        }
    }
}
</script>
